import type { SubjectMemberPayload } from '@Application/Subjects/Members/Actions/subjectMembersFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/** A user who can reach a dossier by membership; the name is resolved from the users of the dossier. */
class SubjectMemberView {
	readonly userId: number;
	readonly access: LabeledValueView;

	constructor(payload: SubjectMemberPayload) {
		this.userId = payload.user.id;
		this.access = new LabeledValueView(payload.access);

		Object.freeze(this);
	}
}

export default SubjectMemberView;
